import sortableGroup from 'ember-sortable/components/sortable-group';

export default sortableGroup;
